<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button> -->
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button> -->
          <el-button class="ik-list-menu-btn" size="medium" @click="listPrintShow">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="goBack">返回</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button> -->
          <!-- <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button> -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button> -->
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="printShow">打印</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main style="display: flex; flex-direction: column;">
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_userCode'"
                v-model="data.head['userCode']"
                code="userCode"
                name="用户编码"
                url="base/user/user/user/find/findPagination"
                :require="true"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onPopupClick="searchPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_userName'"
                v-model="data.head['userName']"
                code="userName"
                name="用户名称"
                default-value=""
                :require="true"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_robotCode'"
                v-model="data.head['robotCode']"
                code="robotCode"
                name="机器人编码"
                url="base/user/robot/robot/find/findPagination"
                :require="true"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onPopupClick="searchPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_robotName'"
                v-model="data.head['robotName']"
                code="robotName"
                name="机器人名称"
                default-value=""
                :require="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_stateSign'"
                v-model="data.head['stateSign']"
                code="stateSign"
                name="报告状态标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.stateSign)"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-datetime
                :ref="'input_diagTime'"
                v-model="data.head['diagTime']"
                code="diagTime"
                name="诊断时间"
                default-value=""
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_storeCode'"
                v-model="data.head['storeCode']"
                url="base/user/user/store/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="storeCode"
                name="门店编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeName'"
                v-model="data.head['storeName']"
                code="storeName"
                name="门店名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
          <el-tabs v-if="mode == 'edit' || mode == 'details'" v-model="active" style="margin: 0 10px; ">
            <el-tab-pane label="体质" name="1">

              <div>
                <div class="mainPhy" style="">
                  <div>
                    <img v-if="data.head.mainPhyCode" :src="require(`@/assets/health/${ data.head.mainPhyCode }.png`)" alt="">
                  </div>
                  <div
                    style="flex: 1; display: flex; justify-content: center; align-items: center; flex-direction: column;"
                  >
                    {{ data.head.mainPhyName }}
                    <div>
                      程度：{{ data.head.mainPhyPct }}%
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/icon/zhutizhi.png" alt="">
                  </div>
                </div>
              </div>
              <div>

                <div style=" display: flex;flex-wrap: wrap">
                  <template v-for="(item, index) in 8">
                    <div v-if="data.head['phy' + (item) + 'Name']" :key="index" class="mainPhy" style="margin: 10px 0; margin-right: 10px;">
                      <img :src="require(`@/assets/health/${data.head['phy' + (item) + 'Code']}.png`)" alt="">
                      <div style="flex: 1;">
                        {{ data.head['phy' + (item) + 'Name'] }}
                        <div>
                          程度：{{ data.head['phyPct' + (item)] }}%
                        </div>
                      </div>
                      <div>
                        <img src="@/assets/icon/futizhi.png" alt="">
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div style="display: flex; margin: 20px 0;">
                <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; " />
                <div>
                  方案
                </div>
              </div>
              <div style="text-align: start;" v-html="schemeHtml.head.htmlContent" />

            </el-tab-pane>
            <el-tab-pane label="面诊" name="2">
              <div style="margin: 10px 0; text-align: start;">
                <img style=" height: 200px;" :src="getsrc(data.head.faceImg)" alt="">
              </div>
              <div>
                <div style="display: flex;">
                  <div class="formItem">
                    指标
                  </div>
                  <div class="formItem" style="width: 300px; ">
                    说明
                  </div>
                  <div class="formItem" style="width: 450px; ">
                    解释
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    面部颜色
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('faceColorSign', data.head.faceColorSign) }}
                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ getText(getOptions('faceColorSign', data.head.faceColorSign)) }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    面部色泽
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('faceLustreSign', data.head.faceLustreSign) }}
                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ getOptions('faceLustreSign', data.head.faceLustreSign) }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    嘴唇检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('lipRecognitionSign', data.head.lipRecognitionSign) }}
                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;" />
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    嘴唇
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('lipColorSign', data.head.lipColorSign) }}
                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ getText(getOptions('lipColorSign', data.head.lipColorSign)) }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="舌诊" name="3">
              <div style="margin: 10px 0; text-align: start;">
                <img style="height: 200px;" :src="getsrc(data.head.tongueImg)" alt="">
              </div>
              <div>
                <div style="display: flex;">
                  <div class="formItem">
                    指标
                  </div>
                  <div class="formItem" style="width: 300px; ">
                    说明
                  </div>
                  <div class="formItem" style="width: 450px; ">
                    解释
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    舌裂纹检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('tongueCrackSign', data.head.tongueCrackSign) }}

                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ data.head.tongueCrackSign == '1'? '纵向/横向沟裂                            阴液枯涸                          阴虚/危候':'' }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    舌胖瘦检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">

                    {{ getOptions('tongueCoatThickSign', data.head.tongueCoatThickSign) }}
                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ data.head.tongueCoatThickSign == '0'? '舌体薄小             气血双亏            实证':'舌体肿胀              水湿内停               虚证' }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    舌苔厚薄检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('tongueFatSign', data.head.tongueFatSign) }}

                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;">
                    {{ data.head.tongueFatSign =='0'? '':"厚苔苔质致密难见舌质     慢性胃炎、慢阻肺、痰饮证" }}
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    舌苔颜色检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('tongueCoatColorSign', data.head.tongueCoatColorSign) }}

                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;" />
                </div>
                <div style="display: flex;">
                  <div class="formItem" style="background: #fff;">
                    舌质颜色检测
                  </div>
                  <div class="formItem" style="width: 300px;background: #fff;">
                    {{ getOptions('tongueColorSign', data.head.tongueColorSign) }}

                  </div>
                  <div class="formItem" style="width: 450px;background: #fff;" />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="问诊" name="4">
              <div style="margin: 10px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/icon/qa.png" alt="" style="margin-right: 8px;">
                  <span style="color: rgb(24, 204, 145);">您自己觉得容易疲劳或乏力吗？</span>
                </div>
                <div style="margin: 20px 0; border-bottom: 1px solid #ccc; color: rgba(86, 87, 93, 0.64); text-align: start;">
                  食少、腹胀、便溏、大腹便便、面色偏暗、无光泽、经常犯困、疲乏嗜睡、舌淡胖、苔白腻、舌边上还有齿痕印、脉濡缓等。
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
            style="flex-shrink: 0;"
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userCode'"
                      v-model="searcher['userCode']"
                      code="userCode"
                      name="用户编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userName'"
                      v-model="searcher['userName']"
                      code="userName"
                      name="用户名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotCode'"
                      v-model="searcher['robotCode']"
                      code="robotCode"
                      name="机器人编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotName'"
                      v-model="searcher['robotName']"
                      code="robotName"
                      name="机器人名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_stateSign'"
                      v-model="searcher['stateSign']"
                      code="stateSign"
                      name="机器人名称"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.stateSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-datetime
                      :ref="'input_minDiagTime'"
                      v-model="searcher['minDiagTime']"
                      code="minDiagTime"
                      name="最早诊断时间"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-datetime
                      :ref="'input_maxDiagTime'"
                      v-model="searcher['maxDiagTime']"
                      code="maxDiagTime"
                      name="最晚诊断时间"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_mainPhyCode'"
                      v-model="searcher['mainPhyCode']"
                      code="mainPhyCode"
                      name="主体质编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_mainPhyName'"
                      v-model="searcher['mainPhyName']"
                      code="mainPhyName"
                      name="主体质名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode1'"
                      v-model="searcher['phyCode1']"
                      code="phyCode1"
                      name="副体质1编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName1'"
                      v-model="searcher['phyName1']"
                      code="phyName1"
                      name="副体质1名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode2'"
                      v-model="searcher['phyCode2']"
                      code="phyCode2"
                      name="副体质2编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName2'"
                      v-model="searcher['phyName2']"
                      code="phyName2"
                      name="副体质2名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode3'"
                      v-model="searcher['phyCode3']"
                      code="phyCode3"
                      name="副体质3编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName3'"
                      v-model="searcher['phyName3']"
                      code="phyName3"
                      name="副体质3名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode4'"
                      v-model="searcher['phyCode4']"
                      code="phyCode4"
                      name="副体质4编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName4'"
                      v-model="searcher['phyName4']"
                      code="phyName4"
                      name="副体质4名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode5'"
                      v-model="searcher['phyCode5']"
                      code="phyCode5"
                      name="副体质5编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName5'"
                      v-model="searcher['phyName5']"
                      code="phyName5"
                      name="副体质5名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode6'"
                      v-model="searcher['phyCode6']"
                      code="phyCode6"
                      name="副体质6编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName6'"
                      v-model="searcher['phyName6']"
                      code="phyName6"
                      name="副体质6名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode7'"
                      v-model="searcher['phyCode7']"
                      code="phyCode7"
                      name="副体质7编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName7'"
                      v-model="searcher['phyName7']"
                      code="phyName7"
                      name="副体质7名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyCode8'"
                      v-model="searcher['phyCode8']"
                      code="phyCode8"
                      name="副体质8编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phyName8'"
                      v-model="searcher['phyName8']"
                      code="phyName8"
                      name="副体质8名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_levelSign'"
                      v-model="searcher['levelSign']"
                      code="levelSign"
                      name="健康评级标识"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.levelSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_phyDiagSign'"
                      v-model="searcher['phyDiagSign']"
                      code="phyDiagSign"
                      name="体质诊断标注标识"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceDiagSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_diagPhyCode'"
                      v-model="searcher['diagPhyCode']"
                      code="diagPhyCode"
                      name="诊断体质编码"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_diagPhyName'"
                      v-model="searcher['diagPhyName']"
                      code="diagPhyName"
                      name="诊断体质名称"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagLevelSign'"
                      v-model="searcher['diagLevelSign']"
                      code="diagLevelSign"
                      name="诊断健康评级标识"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.levelSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_faceRecognitionSign'"
                      v-model="searcher['faceRecognitionSign']"
                      code="faceRecognitionSign"
                      name="面部检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceRecognitionSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_faceColorSign'"
                      v-model="searcher['faceColorSign']"
                      code="faceColorSign"
                      name="面部颜色结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_faceLustreSign'"
                      v-model="searcher['faceLustreSign']"
                      code="faceColorSign"
                      name="面部色泽结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceLustreSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_lipRecognitionSign'"
                      v-model="searcher['lipRecognitionSign']"
                      code="lipRecognitionSign"
                      name="嘴唇检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.lipRecognitionSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_lipColorSign'"
                      v-model="searcher['lipColorSign']"
                      code="lipColorSign"
                      name="嘴唇颜色结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.lipColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_lipColorSign'"
                      v-model="searcher['lipColorSign']"
                      code="lipColorSign"
                      name="嘴唇颜色结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.lipColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_faceDiagSign'"
                      v-model="searcher['faceDiagSign']"
                      code="faceDiagSign"
                      name="面诊诊断标注标识"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceDiagSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagFaceColorSign'"
                      v-model="searcher['diagFaceColorSign']"
                      code="diagFaceColorSign"
                      name="诊断面部颜色结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagFaceLustreSign'"
                      v-model="searcher['diagFaceLustreSign']"
                      code="diagFaceColorSign"
                      name="诊断面部色泽结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceLustreSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagLipColorSign'"
                      v-model="searcher['diagLipColorSign']"
                      code="diagLipColorSign"
                      name="诊断嘴唇颜色结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.lipColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueRecognitionSign'"
                      v-model="searcher['tongueRecognitionSign']"
                      code="tongueRecognitionSign"
                      name="舌体检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueRecognitionSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueCrackSign'"
                      v-model="searcher['tongueCrackSign']"
                      code="tongueCrackSign"
                      name="舌裂纹检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCrackSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueFatSign'"
                      v-model="searcher['tongueFatSign']"
                      code="tongueFatSign"
                      name="舌胖瘦检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueFatSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueCoatThickSign'"
                      v-model="searcher['tongueCoatThickSign']"
                      code="tongueCoatThickSign"
                      name="舌苔厚薄检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCoatThickSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueCoatColorSign'"
                      v-model="searcher['tongueCoatColorSign']"
                      code="tongueCoatColorSign"
                      name="舌苔颜色检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCoatColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueColorSign'"
                      v-model="searcher['tongueColorSign']"
                      code="tongueColorSign"
                      name="舌质颜色检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueDiagSign'"
                      v-model="searcher['tongueDiagSign']"
                      code="tongueDiagSign"
                      name="舌诊诊断标注标识"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.faceDiagSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagTongueCrackSign'"
                      v-model="searcher['diagTongueCrackSign']"
                      code="diagTongueCrackSign"
                      name="诊断舌裂纹检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCrackSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagTongueFatSign'"
                      v-model="searcher['diagTongueFatSign']"
                      code="diagTongueFatSign"
                      name="诊断舌胖瘦检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueFatSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagTongueCoatThickSign'"
                      v-model="searcher['diagTongueCoatThickSign']"
                      code="diagTongueCoatThickSign"
                      name="诊断舌苔厚薄检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCoatThickSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_diagTongueCoatColorSign'"
                      v-model="searcher['diagTongueCoatColorSign']"
                      code="diagTongueCoatColorSign"
                      name="诊断舌苔颜色检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueCoatColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_tongueColorSign'"
                      v-model="searcher['tongueColorSign']"
                      code="tongueColorSign"
                      name="诊断舌质颜色检测结果"
                      :disabled="false"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.tongueColorSign)"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <div v-if="viewMode == 'list'" style="flex: 1; overflow: hidden; margin-bottom: 30px;">
          <el-table
            ref="table"
            v-loading="listLoading"
            :data="tableData"
            element-loading-text="加载中..."
            :stripe="true"
            :border="true"
            :fit="true"
            class="ik-list-table"
            height="calc(100vh - 360px)"
            :header-row-class-name="'ik-list-table-header-row'"
            :header-cell-class-name="'ik-list-table-header-cell'"
            :row-class-name="'ik-list-table-body-row'"
            :cell-class-name="'ik-list-table-body-cell'"
            :highlight-current-row="true"
            @row-click="rowClick"
          >
            <ik-column-text
              code="code"
              name="编码"
              :edit="false"
            />
            <ik-column-text
              code="name"
              name="名称"
              :edit="false"
            />
            <ik-column-text
              code="userCode"
              name="用户编码"
              :edit="false"
            />
            <ik-column-text
              code="userName"
              name="用户名称"
              :edit="false"
            />
            <ik-column-text
              code="robotCode"
              name="机器人编码"
              :edit="false"
            />
            <ik-column-text
              code="robotName"
              name="机器人名称"
              :edit="false"
            />
            <ik-column-select
              code="stateSign"
              name="报告状态标识"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.stateSign)"
            />
            <ik-column-datetime
              code="diagTime"
              name="诊断时间"
              :edit="false"
            />
            <ik-column-text
              code="mainPhyCode"
              name="主体质编码"
              :edit="false"
            />
            <ik-column-text
              code="mainPhyName"
              name="主体质名称"
              :edit="false"
            />
            <ik-column-number
              code="mainPhyPct"
              name="主体质程度"
              :edit="false"
            />
            <ik-column-text
              code="phy1Code"
              name="副体质1编码"
              :edit="false"
            />
            <ik-column-text
              code="phy1Name"
              name="副体质1名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct1"
              name="副体质1程度"
              :edit="false"
            />
            <ik-column-text
              code="phy2Code"
              name="副体质2编码"
              :edit="false"
            />
            <ik-column-text
              code="phy2Name"
              name="副体质2名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct2"
              name="副体质2程度"
              :edit="false"
            />
            <ik-column-text
              code="phy3Code"
              name="副体质3编码"
              :edit="false"
            />
            <ik-column-text
              code="phy3Name"
              name="副体质3名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct3"
              name="副体质3程度"
              :edit="false"
            />
            <ik-column-text
              code="phy4Code"
              name="副体质4编码"
              :edit="false"
            />
            <ik-column-text
              code="phy4Name"
              name="副体质4名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct4"
              name="副体质4程度"
              :edit="false"
            />
            <ik-column-text
              code="phy5Code"
              name="副体质5编码"
              :edit="false"
            />
            <ik-column-text
              code="phy5Name"
              name="副体质5名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct5"
              name="副体质5程度"
              :edit="false"
            />
            <ik-column-text
              code="phy6Code"
              name="副体质6编码"
              :edit="false"
            />
            <ik-column-text
              code="phy6Name"
              name="副体质6名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct6"
              name="副体质6程度"
              :edit="false"
            />
            <ik-column-text
              code="phy7Code"
              name="副体质7编码"
              :edit="false"
            />
            <ik-column-text
              code="phy7Name"
              name="副体质7名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct7"
              name="副体质7程度"
              :edit="false"
            />
            <ik-column-text
              code="phy8Code"
              name="副体质8编码"
              :edit="false"
            />
            <ik-column-text
              code="phy8Name"
              name="副体质8名称"
              :edit="false"
            />
            <ik-column-number
              code="phyPct8"
              name="副体质8程度"
              :edit="false"
            />
            <ik-column-select
              code="phyDiagSign"
              name="体质诊断标注标识"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.phyDiagSign)"
            />
            <ik-column-image-oss
              code="faceImg"
              name="诊断健康指数"
              :edit="false"
            />
            <ik-column-select
              code="faceRecognitionSign"
              name="面部检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceRecognitionSign)"
            />
            <ik-column-select
              code="faceColorSign"
              name="面部颜色结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceColorSign)"
            />
            <ik-column-select
              code="faceLustreSign"
              name="面部色泽结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceLustreSign)"
            />
            <ik-column-select
              code="lipRecognitionSign"
              name="嘴唇检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.lipRecognitionSign)"
            />
            <ik-column-select
              code="lipColorSign"
              name="嘴唇颜色结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.lipColorSign)"
            />
            <ik-column-select
              code="faceDiagSign"
              name="面诊诊断标注标识"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.lipColorSign)"
            />
            <ik-column-select
              code="diagFaceColorSign"
              name="诊断面部颜色结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceColorSign)"
            />
            <ik-column-select
              code="diagFaceLustreSign"
              name="诊断面部色泽结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceLustreSign)"
            />
            <ik-column-select
              code="diagLipColorSign"
              name="诊断嘴唇颜色结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.lipColorSign)"
            />
            <ik-column-image-oss
              code="tongueImg"
              name="舌诊图像"
              :edit="false"
            />
            <ik-column-select
              code="tongueRecognitionSign"
              name="舌体检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueRecognitionSign)"
            />
            <ik-column-select
              code="tongueCrackSign"
              name="舌裂纹检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCrackSign)"
            />
            <ik-column-select
              code="tongueFatSign"
              name="舌胖瘦检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueFatSign)"
            />
            <ik-column-select
              code="tongueCoatThickSign"
              name="舌胖瘦检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCoatThickSign)"
            />
            <ik-column-select
              code="tongueCoatColorSign"
              name="舌苔颜色检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCoatColorSign)"
            />
            <ik-column-select
              code="tongueColorSign"
              name="舌质颜色检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueColorSign)"
            />
            <ik-column-select
              code="tongueDiagSign"
              name="舌诊诊断标注标识"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.faceDiagSign)"
            />
            <ik-column-select
              code="diagTongueCrackSign"
              name="诊断舌裂纹检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCrackSign)"
            />
            <ik-column-select
              code="diagTongueFatSign"
              name="诊断舌胖瘦检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueFatSign)"
            />
            <ik-column-select
              code="diagTongueCoatThickSign"
              name="舌胖瘦检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCoatThickSign)"
            />
            <ik-column-select
              code="diagTongueCoatColorSign"
              name="舌苔颜色检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueCoatColorSign)"
            />
            <ik-column-select
              code="diagTongueColorSign"
              name="舌质颜色检测结果"
              :edit="false"
              key-field="key"
              value-field="value"
              :options="toJson(jsonStr.tongueColorSign)"
            />
          </el-table>
        </div>

      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <div v-if="viewMode == 'list'" class="pagination-bar">
          <el-pagination
            :current-page.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes, jumper"
            @size-change="find"
            @current-change="find"
          />
        </div>
      </el-footer>
    </el-container>
    <Print ref="printRef" :print-data="data.head" :scheme-list="schemeList" :scheme-html="schemeHtml" class="print-override" />
  </el-container>
</template>
<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormDatetime from '@/components/ik/form/input/IkFormDatetime'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnImageOss from "@/components/ik/table/ikColumn/IkColumnImageOss"
import IkColumnDatetime from '@/components/ik/table/ikColumn/IkColumnDatetime'
import store from '@/store'
import { getScheme, getcontentlist, getfindByCode } from '@/api/ik/data/health'
import { getSrc } from '@/utils/ik/oss/oss.js'
import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
import Print from './print.vue'
import dayjs from 'dayjs'

export default {
  components: {
    // 表单组件
    IkFormText,
    IkFormSelect,
    IkFormDatetime,
    IkFormDataPopup,
    IkColumnText,
    IkColumnNumber,
    IkColumnSelect,
    IkColumnImageOss,
    IkColumnDatetime,
    Print
  },
  props: {
    dialogQuery: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'health/diagnosis/physique/phydiagrecord',
      // Web路径
      webPath: 'inspect/PhyDiagRecord',
      // 标识字段JSON
      jsonStr: {
        levelSign: '[{ "key": "1", "value": "健康" },{ "key": "2", "value": "亚健康" },{ "key": "3", "value": "建议就医" }]',
        tongueColorSign: '[{ "key": "0", "value": "舌暗红" },{ "key": "1", "value": "舌淡白" },{ "key": "2", "value": "舌淡红" },{ "key": "3", "value": "舌红" },{ "key": "4", "value": "舌深红(舌紫)" }]',
        tongueCoatColorSign: '[{ "key": "0", "value": "苔白" },{ "key": "1", "value": "苔黄" }]',
        tongueCoatThickSign: '[{ "key": "0", "value": "薄" },{ "key": "1", "value": "胖舌" }]',
        tongueFatSign: '[{ "key": "0", "value": "正常" },{ "key": "1", "value": "厚" }]',
        tongueCrackSign: '[{ "key": "0", "value": "未检测到舌裂纹" },{ "key": "1", "value": "检测到舌裂纹" }]',
        tongueRecognitionSign: '[{ "key": "0", "value": "未测出舌象" },{ "key": "1", "value": "测出舌象" }]',
        faceDiagSign: '[{ "key": "0", "value": "未标注" },{ "key": "1", "value": "已标注" }]',
        lipColorSign: '[{ "key": "0", "value": "淡白" },{ "key": "1", "value": "淡红" },{ "key": "2", "value": "红" },{ "key": "3", "value": "暗红" },{ "key": "4", "value": "紫" }]',
        lipRecognitionSign: '[{ "key": "0", "value": "未测出嘴唇" },{ "key": "1", "value": "测出嘴唇" }]',
        faceLustreSign: '[{ "key": "0", "value": "有光泽" },{ "key": "1", "value": "少光泽" },{ "key": "2", "value": "无光泽" }]',
        faceColorSign: '[{ "key": "0", "value": "面白" },{ "key": "1", "value": "面黑" },{ "key": "2", "value": "面红" },{ "key": "3", "value": "面黄" },{ "key": "4", "value": "面青" },{ "key": "5", "value": "正常" }]',
        faceRecognitionSign: '[{ "key": "0", "value": "未测出人脸" },{ "key": "1", "value": "测出人脸" }]',
        phyDiagSign: '[{ "key": "1", "value": "未标注" },{ "key": "2", "value": "已标注" }]',
        stateSign: '[{ "key": "1", "value": "未出报告" },{ "key": "2", "value": "已出报告" }]',
        effectiveSign: '[{"key": "0", "value": "无效"}, {"key": "1", "value": "有效"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      },
      schemeList: [],
      schemeHtml: {
        head: {
          htmlContent: ''
        }
      },
      // tabs切换
      active: '1'
    }
  },
  computed: {
  },
  watch: {
  },
  async created() {
    // 弹窗模式：通过 props 传入查询参数
    if (this.dialogQuery) {
      this.viewMode = "list"
      this.mode = "list"
      this.id = 0
      // 将外部查询参数合并到搜索条件
      Object.keys(this.dialogQuery).forEach(key => {
        this.$set(this.searcher, key, this.dialogQuery[key])
      })
      this.find()
    } else {
      // 获取视图模式
      this.viewMode = this.$route.params.viewMode || "list"
      this.mode = this.$route.params.mode || "list"
      this.id = this.$route.query.id || 0
      // 初始化界面，设置模式取值
      if (this.mode === "list") {
        this.viewMode = "list"
      } else {
        this.viewMode = "info"
      }
      // 列表页进入时的处理
      if (this.viewMode === "list") {
        // 处理从统计页面跳转过来的查询参数
        this.handleExternalQueryParams()
        this.find()
      } else if (this.viewMode === "info") {
        if (this.id !== 0) {
          await this.get(this.id)
        }
      }
    }
    this.getText()
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页打印按钮点击
    async listPrintShow() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要打印的行!'
        })
      } else {
        await $this.get($this.activeRow.id, true)
      }
    },
    // 返回上一页
    goBack() {
      if (this.dialogQuery) {
        this.$emit('close')
      } else {
        this.$router.go(-1)
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      if (this.dialogQuery) {
        this.$emit('close')
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
      }
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
      console.log(this.activeRow)
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "userCode") {
        this.searcher["userCode"] = row.code
        this.searcher["userName"] = row.name
        this.searcher["userId"] = row.id
      } else if (code === "robotCode") {
        this.searcher["robotCode"] = row.code
        this.searcher["robotName"] = row.name
        this.searcher["robotId"] = row.id
      } else if (code === "storeCode") {
        this.searcher["storeId"] = row.id
        this.searcher["storeCode"] = row.code
        this.searcher["storeName"] = row.name
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "allergyDictionaryCode") {
        this.data.head["allergyDictionaryId"] = row.id
        this.data.head["allergyDictionaryCode"] = row.code
        this.data.head["allergyDictionaryName"] = row.name
        this.data.head["dicDescribe"] = row.dicDescribe
        this.data.head["pinyinCode"] = row.pinyinCode
      } else if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id, printShow) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
        $this.getFangan()
        if (printShow) {
          $this.printShow()
        }
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      // 如果没有外部传入的门店编码，则默认使用当前登录用户的门店编码
      if (!$this.searcher.storeCode) {
        $this.searcher.storeCode = $this.storeCode
      }
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 启用词典
    listOpenBtn() {
      const $this = this
      postData(this.bgPath + "/do/enabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已启用!'
        })
      })
    },
    // 停用词典
    listCloseBtn() {
      const $this = this
      postData(this.bgPath + "/do/disabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已禁用!'
        })
      })
    },
    // 同步词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + "/do/syncdic", { "storeCode": $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    },
    getOptions(code, key) {
      let text = ''
      this.toJson(this.jsonStr[code]).forEach(element => {
        if (key === element.key) {
          text = element.value
        }
      })
      return text
    },
    getText(code1) {
      const data = require('./phy.json')
      let value = ''
      console.log(data)
      data.forEach(e => {
        if (code1 === e.column2) {
          value = e.column3
        }
      })
      return value
    },
    getsrc(url) {
      if (url) {
        return getSrc('', url)
      }
    },
    getFangan() {
      const param = {
        data: {
          phyTypeCode: this.data.head.mainPhyCode,
          storeCode: this.data.head.storeCode,
          sexSign: typeof this.data.head.sexSign === 'number' ? this.data.head.sexSign : 1
        }
      }
      const param2 = {
        code: ''
      }
      getScheme(this.bgPath, param).then(res => {
        param.data.count = 6
        param.data.inspectTypeCode = res.data.contentInfoCode
        param2.code = res.data.contentInfoCode
        getcontentlist(this.bgPath, param).then(res => {
          this.schemeList = res.data
        })
        getfindByCode('', param2).then(res => {
          this.schemeHtml = res.data
        })
      })
    },
    printShow() {
      this.data.head.age = dayjs().diff(this.data.head.birthDate, 'years')
      this.$refs.printRef.show = true
      // 弹窗模式下将打印预览弹窗移动到 body 根目录，突破外层弹窗的层叠上下文限制
      if (this.dialogQuery) {
        this.$nextTick(() => {
          setTimeout(() => {
            const printWrapper = document.querySelector('.print-override.el-dialog__wrapper')
            if (printWrapper && printWrapper.parentElement !== document.body) {
              document.body.appendChild(printWrapper)
            }
          }, 150)
        })
      }
    },
    // 处理从统计页面跳转过来的查询参数
    handleExternalQueryParams() {
      const query = this.$route.query
      // let hasParams = false
      const fields = [
        'mainPhyCode', 'mainPhyName',
        'phyCode1', 'phyName1', 'phyCode2', 'phyName2',
        'phyCode3', 'phyName3', 'phyCode4', 'phyName4',
        'phyCode5', 'phyName5', 'phyCode6', 'phyName6',
        'phyCode7', 'phyName7', 'phyCode8', 'phyName8',
        'robotCode', 'robotName',
        'storeCode', 'storeName',
        'minDiagTime', 'maxDiagTime'
      ]
      fields.forEach(field => {
        if (query[field] !== undefined && query[field] !== '') {
          this.$set(this.searcher, field, query[field])
        }
      })
      // if (hasParams) {
      //   this.searcherActive = "1"
      // }
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
.formItem {
  width: 150px;
  background: rgb(242, 243, 245);
  border: 1px solid rgb(229, 230, 235);
  min-height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.mainPhy {
  display: flex;
  align-items: center;
  border: 1px solid rgb(229, 233, 239);
  width: 280px;
  padding: 5px;
}
/* 布局样式 */
.el-aside {
  height: calc(100vh - 88px);
  width: 100%;
  border-right: 1px solid #1482f0;
}

.el-header, .el-footer {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}

/* 树形菜单样式 */
.ik-list-tree-title {
  color: #1482f0;
  border: 0px;
  width: 100%;
  height: 42px;
  background-color: #FFFFFF;
  line-height: 40px;
  font-size: 14px;
}

.ik-list-tree-close {
  margin-right: 20px;
  float: right;
  font-size: 16px;
}

/* 树形菜单选中样式 */
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #FFFFFF !important;
  color: #1482f0;
}

/* 树形菜单移入样式 */
.el-tree-node__content:hover {
  background-color: #F4F7FC !important;
  color: #1482f0;
}

/* 菜单样式 */
.ik-list-title {
  background-color: #FFFFFF;
  color: #1482f0;
  margin-left: 25px;
  width: 300px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
}

.ik-list-menu {
  margin-top: 3px;
  margin-left: 20px;
  float: right;
}

.ik-list-menu-btn {
  background-color: #1482f0;
  color: #FFFFFF;
  border-radius: 25px;
}

.searcher {
  overflow: hidden !important;
}

.searcher .el-dialog__header {
  padding: 0px;
  display: none;
}

.searcher .el-dialog__body {
  padding: 0px;
  height: 100%;
}

</style>

<style lang="scss" scoped>
.el-table {
  .el-table__fixed {
    height: auto !important;
    bottom: 17px;
  }

  /* 表格样式 */
  .ik-list-table-header-cell {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background-color: #F4F7FC;
    color: #555555;
    border-color: #E7E7E7;

  }

  .ik-list-table-header-row {
    padding: 0;
    height: 50px;
    line-height: 50px;
    background-color: #F4F7FC;
    color: #555555;
    border-color: #E7E7E7;

    th {
      padding: 0;
    }

  }

  .ik-list-table-header-row .ik-list-table-header-cell > .cell {
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ik-list-table-body-row {
    padding: 0;
    height: 45px;
    line-height: 45px;
  }

  .ik-list-table-body-row-hide {
    display: none;
  }

  .ik-list-table-body-cell {
    padding: 0;
    // height: 40px;
    // line-height: 40px;
  }
}

/* 菜单样式 */
.ik-table-menu {
  z-index: 2000;
  position: fixed;
  padding: 0px;
  color: #000000;
  border-radius: 5px;
  border: 1px solid #999999;
  background-color: #FFFFFF;
}

.ik-list-table {
  overflow-x: scroll;

  ::v-deep.el-table__body-wrapper {
    //加上不显示
    //height: calc(100% - 50px)!important;
  }
}

.ik-table-menu-item {
  padding-right: 20px;
  padding-left: 20px;
  width: 120px;
  height: 30px;
  cursor: pointer;
  border-radius: 5px;
  display: block;
  line-height: 30px;
  text-align: center;
}

li:hover {
  background-color: #1790ff;
  color: #FFFFFF;
}
.pagination-bar {
  height: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 15px;

  .el-pagination {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    /* 左侧：共 X 条 */
    .el-pagination__total {
      margin-right: auto;
      font-size: 13px;
      color: #606266;
    }

    /* 中间：页码按钮去背景、扁平化 */
    .btn-prev,
    .btn-next,
    .el-pager li {
      background: transparent;
      border: none;
      font-size: 13px;
      color: #606266;
      min-width: 28px;
      height: 28px;
      line-height: 28px;
    }
    .el-pager li.active {
      color: #409eff;
      font-weight: bold;
    }

    /* 右侧：20条/页 下拉 */
    .el-pagination__sizes {
      margin-left: 10px;
      .el-input .el-input__inner {
        font-size: 13px;
        padding: 0 5px;
        height: 28px;
        line-height: 28px;
      }
    }

    /* 右侧：前往 X 页 */
    .el-pagination__jump {
      margin-left: 10px;
      font-size: 13px;
      color: #606266;
      .el-input__inner {
        font-size: 13px;
        padding: 0 3px;
        height: 28px;
        line-height: 28px;
        width: 40px;
        text-align: center;
      }
    }
  }
}
</style>
